import React from 'react';

/*
  Comparativa Piso SPC Luxury vs Piso laminado.
  - Escritorio: tabla con la columna SPC resaltada.
  - Móvil (<768px): cada fila se convierte en tarjeta (ver PisoSpcPremium.css, sección 4).
  - Los roles ARIA se declaran explícitos porque al cambiar el display de
    table/tr/td en móvil algunos navegadores pierden la semántica de tabla.
  Icono: 'ok' (✓) | 'no' (×) | undefined (sin icono)
*/
const FILAS = [
  {
    criterio: 'Agua y humedad',
    spc: 'Resiste el agua, no se hincha',
    spcIcono: 'ok',
    laminado: 'Se daña o se hincha si se moja',
    laminadoIcono: 'no',
  },
  {
    criterio: 'Cocinas y baños',
    spc: 'Sí, ideal',
    spcIcono: 'ok',
    laminado: 'No recomendado',
    laminadoIcono: 'no',
  },
  {
    criterio: 'Durabilidad',
    spc: 'Alta, aguanta tráfico intenso',
    laminado: 'Media, se desgasta más rápido en zonas de uso fuerte',
  },
  {
    criterio: 'Cambios de temperatura',
    spc: 'Estable, no se dilata ni se mueve',
    laminado: 'Puede moverse o abrirse',
  },
  {
    criterio: 'Instalación',
    spc: 'Sistema click, sin pegamento',
    laminado: 'Sistema click',
  },
  {
    criterio: 'Al caminar',
    spc: 'Suave, con base acolchada',
    laminado: 'Más duro y puede sonar hueco',
  },
  {
    criterio: 'Limpieza',
    spc: 'Trapeador con jabón neutro, sin miedo al agua',
    laminado: 'Se limpia casi seco, evitar exceso de agua',
  },
  {
    criterio: 'Ideal para',
    spc: 'Hogares, cocinas, baños, oficinas, hospitales, gimnasios',
    laminado: 'Recámaras, salas y espacios secos con poco tráfico',
  },
];

const PUNTOS = [
  {
    icono: 'fa-droplet',
    texto: 'No le afecta la humedad, así que no se levanta ni se hincha.',
  },
  {
    icono: 'fa-person-walking',
    texto: 'Se ve elegante y resiste el paso constante de personas.',
  },
  {
    icono: 'fa-tree',
    texto:
      'Se ve como un piso de madera, pero aguanta mucho más el uso diario, la humedad y el tráfico.',
  },
];

const Celda = ({ icono, children }) => (
  <div className="spc-compare__cell">
    {icono && (
      <i
        className={`fa-solid ${icono === 'ok' ? 'fa-check' : 'fa-xmark'} spc-compare__ico spc-compare__ico--${icono}`}
        aria-hidden="true"
      ></i>
    )}
    <span>{children}</span>
  </div>
);

const ComparativaSpcPremium = () => {
  return (
    <section id="comparativa" className="spc-compare spc-section">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-9 text-center wow fadeIn" data-wow-delay="200ms">
            <div className="mb-1-9 title-style5">
              <span className="sub-title">Comparativa</span>
              <h2 className="display-5 lh-1 font-weight-800 mb-0">
                Piso SPC Luxury vs. Piso laminado: ¿cuál te conviene?
              </h2>
            </div>
            <p className="spc-compare__intro mb-0">
              Se parecen por fuera, pero son distintos por dentro. Aquí va la diferencia.
            </p>
          </div>
        </div>

        <div className="spc-compare__panel wow fadeIn" data-wow-delay="300ms">
          <table className="spc-compare__table" role="table">
            <caption className="visually-hidden">
              Comparativa entre Piso SPC Luxury y piso laminado
            </caption>
            <colgroup>
              <col className="spc-compare__col-criterio" />
              <col className="spc-compare__col-spc" />
              <col className="spc-compare__col-lam" />
            </colgroup>
            <thead role="rowgroup">
              <tr role="row">
                <th scope="col" role="columnheader">
                  <span className="visually-hidden">Característica</span>
                </th>
                <th scope="col" role="columnheader" className="spc-compare__th-spc">
                  Piso SPC Luxury
                </th>
                <th scope="col" role="columnheader">
                  Piso laminado
                </th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              {FILAS.map((fila) => (
                <tr key={fila.criterio} role="row">
                  <th scope="row" role="rowheader">
                    {fila.criterio}
                  </th>
                  <td
                    role="cell"
                    className="spc-compare__td-spc"
                    data-label="Piso SPC Luxury"
                  >
                    <Celda icono={fila.spcIcono}>{fila.spc}</Celda>
                  </td>
                  <td
                    role="cell"
                    className="spc-compare__td-lam"
                    data-label="Piso laminado"
                  >
                    <Celda icono={fila.laminadoIcono}>{fila.laminado}</Celda>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <ul className="spc-compare__points">
          {PUNTOS.map((punto, index) => (
            <li
              key={punto.icono}
              className="spc-compare__point wow fadeInUp"
              data-wow-delay={`${(index + 1) * 150}ms`}
            >
              <span className="spc-compare__point-icon" aria-hidden="true">
                <i className={`fa-solid ${punto.icono}`}></i>
              </span>
              <p>{punto.texto}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ComparativaSpcPremium;